var xhr = require('../utils/xhr');

module.exports = {
    getAnswers: function(callback) {
        xhr.simpleCall({
            func: 'answers'
        }, function (res) {
            callback(res.data);
        });
    },
    getMessages: function(callback){
        xhr.simpleCall({
            func:'message'
        },function(res) {
            callback(res.data);
        });
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/message/service.js
 ** module id = 45
 ** module chunks = 0
 **/